import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";
import YoutubeEmbed from '../components/Youtube';

import cover from "../assets/img/elemental-frame1.webp";
import img1 from "../assets/img/elemental2.png";
import img2 from "../assets/img/elemental3.png";
import img3 from "../assets/img/elemental4.png";
import video from "../assets/vid/elemental-video.mp4";


export const projectDetails: ProjectInterface = {
    url: "elemental-blitz",
    title: "Elemental Blitz",
    summary: "Shoot’em up game done for a college assignment.",
    description: `This game was created for a college assignment that I've made together with colleague.

        It draws inspiration from retro shoot 'em up titles. With a bullet hell style, it pits players against waves of foes and stage bosses. Each of the three progressive stages, including a semi-boss encounter in the initial stage, contributes to preparing players for the ultimate boss battle in the third phase.

        We added a conditional hit mechanic based on elemental interactions where the players have to constantly choose the correct element, adding depth to the gameplay and creates an exhilarating and challenging experience by blending frantic action with a bit of strategy.`,
    year: "2023",
    tags: ["Arcade", "Shoot'em Up", "Fast-paced", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.COLLEGE,
    people: 2,
    platforms: ["Desktop"],
    roles: ["Gameplay Programmer", "Game Designer"],
    technologies: ["Unity", "C#", "Desktop"],
    collaborators: ["Lucas Coutinho", "[link=Caio Vieira|https://caiov.itch.io/]"],
    highlightColor: "#60151F",
    descriptionTitle: "Elemental Shoot 'Em Up",
    linkData: [
        { type: 'github', url: "https://github.com/ti1puc/elemental-blitz" },
        { type: 'itchio', url: "https://lucasctnh.itch.io/elemental-blitz" },
    ],
    relatedProjects: ["PuzzleCave", "Asteroids", "CheckMore"],
};


export function ElementalBlitz() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={true}
                carouselData={[
                    { image: img1, caption: "Gameplay" },
                    { image: img2, caption: "Gameplay" },
                    { image: img3, caption: "Gameplay" },
                ]}
                leftContent={
                    <div className="a-left-no-bg">
                        <YoutubeEmbed embedId="zIo9Q_Rw9UA" />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}